module.exports = __webpack_public_path__ + "img/huelva.b745b4c8.jpg";